module.exports = __webpack_public_path__ + "img/share-from-square.1f4837fb.svg";